"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxSubGroup = void 0;
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _CheckboxGroupContext = _interopRequireDefault(require("./CheckboxGroupContext"));
var _styles = require("@mui/styles");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    checkboxSubList: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "30px"
    }
  };
});
var CheckboxSubGroup = exports.CheckboxSubGroup = function CheckboxSubGroup(_ref) {
  var children = _ref.children,
    label = _ref.label,
    disabled = _ref.disabled;
  var classes = useStyles();
  var parentContext = (0, _react.useContext)(_CheckboxGroupContext["default"]);
  var value = parentContext.value,
    onChange = parentContext.onChange;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    childValues = _useState2[0],
    setChildValues = _useState2[1];
  var allSelected = childValues.every(function (childV) {
    return value.includes(childV);
  });
  var someSelected = childValues.some(function (childV) {
    return value.includes(childV);
  });
  var handleToggleAll = (0, _react.useCallback)(function (event) {
    onChange(event, childValues);
  }, [onChange, childValues]);
  var handleRegister = (0, _react.useCallback)(function (childV) {
    setChildValues(function (v) {
      return [].concat(_toConsumableArray(v), [childV]);
    });
  }, []);
  var handleUnregister = (0, _react.useCallback)(function (childV) {
    setChildValues(function (v) {
      return v.filter(function (vv) {
        return vv !== childV;
      });
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckboxGroupContext["default"].Provider, {
    value: _objectSpread(_objectSpread({}, parentContext), {}, {
      register: handleRegister,
      unregister: handleUnregister
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox["default"], {
      indeterminate: !allSelected && someSelected,
      checked: allSelected,
      label: label ? label : allSelected ? "Deselect All" : "Select All",
      onChange: handleToggleAll,
      disabled: disabled
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.checkboxSubList,
      children: children
    })]
  });
};